import { Component } from '@angular/core';

@Component({
	selector: 'security-information',
	template: require('./security-information.component.html'),
	host: { class: 'flex-column min-height-full-vh-bg-color' },
})
export class SecurityInformationComponent {
	public simSwapFaqDocUrl: string = './Content/documents/SIM_SWAP_FAQ.pdf';
}
